module.exports = __webpack_public_path__ + "img/0Q3A6453_L_BlackMatted_MockedUp.a0c24a69.jpg";